import {useFormContext} from "react-hook-form";
import {FiGlobe, FiLock, FiUsers} from "react-icons/fi";

import {FormLabel} from "@/components/form/FormLabel.tsx";
import {SelectionCard} from "@/components/selectionCard/SelectionCard.tsx";
import {StatusPageVisibilityLevel} from "@/lib/types/statuspages.ts";
import {FieldProps} from "@/pages/checks/components/form/fields/common.ts";

type VisibilityFieldProps = Pick<FieldProps, "name" | "label" | "required" | "className" | "disabled">;

export const VisibilityField = ({
  name = "visibility_level",
  label = "Visibility",
  required,
  className,
  disabled,
}: VisibilityFieldProps) => {
  const {watch, setValue} = useFormContext();
  const value = watch(name);

  const handleChange = (newValue: string) => {
    setValue(name, newValue, {shouldDirty: true, shouldTouch: true});
  };

  return (
    <div className={className}>
      <FormLabel forId={name} required={required}>
        {label}
      </FormLabel>
      <SelectionCard value={value} onChange={handleChange}>
        <SelectionCard.Option
          value={StatusPageVisibilityLevel.PUBLIC}
          icon={FiGlobe}
          title="Public"
          description="Anyone with the link can view"
          disabled={disabled}
        />
        <SelectionCard.Option
          value={StatusPageVisibilityLevel.EXTERNAL_USERS}
          icon={FiLock}
          title="Private"
          description="Users must be invited to view the Page"
          disabled={disabled}
        />
        <SelectionCard.Option
          value={StatusPageVisibilityLevel.UPTIME_USERS}
          icon={FiUsers}
          title="Uptime Users"
          description="Visible to your Uptime.com account users"
          disabled={disabled}
        />
      </SelectionCard>
    </div>
  );
};
